import './App.css';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { Link, Outlet } from "react-router-dom";

import { firebaseConfig, vapidKey } from './firebase/firebaseConfig'

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// messaging
const messaging = getMessaging();

getToken(messaging, { vapidKey: vapidKey }).then((currentToken) => {
  if (currentToken) {
    // 取得 currentToken，需傳回 server
    console.log('get currentToken');
    console.log(currentToken);
  } else {
    console.log('No registration token available. Request permission to generate one.');
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
});

// 要求 notification 授權
if ('Notification' in window) {
  console.log('Notification.permission:' + Notification.permission);
  if (Notification.permission != 'granted') {
    console.log('Ask user permission')
    Notification.requestPermission(status => {
      console.log('Status:' + status)
    });
  }
}

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  const notificationTitle = 'Message Title';
  const notificationOptions = {
    body: 'Message body.',
    icon: '/logo192.png'
  };
  new Notification(notificationTitle,
    notificationOptions)
});

function App() {
  return (
    <div className="App">
      <div>havocFire 測試頁面</div>
      <nav
        style={{
          borderBottom: "solid 1px",
        }}
      >
        <Link to="/">首頁</Link> |{" "}
        <Link to="/register">註冊頁</Link> |{" "}
        <Link to="/login">登入頁</Link>
      </nav>
      <Outlet />
    </div>
  );
}

export default App;
